var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOmaSaastopankki(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 359.3 135.5",
    style: {
      enableBackground: "new 0 0 359.3 135.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1DCA7A"
    },
    d: "M136.9,49.1c8.3,0,13.3,5.1,13.3,14.1v38.7h9.2V62.8c0-12.9-7.6-21.3-21.5-21.3c-10.8,0-17.1,5.2-20.5,12.3 c-2.8-6.9-10.1-12.3-19.9-12.3c-7.7,0-14.1,2.8-18.7,10v-8.4h-9.1v58.8h9.2V64.8c0-8.7,6.5-15.7,17.5-15.7c8.4,0,13.5,5.1,13.5,14.1 v38.7h9.2V65.5C119.2,55.2,126.4,49.1,136.9,49.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1DCA7A"
    },
    d: "M320.4,30.1h8.9c0-1.7,0-3.1-0.4-5.2C326,8.9,312.9,0,298.5,0c-16.8,0-30.3,12.8-30.3,30.1 c0,18.8,11.3,25.6,11.3,43.2c0,12.8-8,22.5-20.5,22.5c-12.9,0-21.2-10.7-21.2-23.3c0-12.5,8-21.1,16.9-22.5c0.8-0.1,2.3-0.3,3.1-0.3 V42c-0.9,0-2.4,0.1-3.6,0.3c-12.1,1.5-25.6,12-25.6,30.3c0,17.1,12.5,30.9,30.3,30.9c17.3,0,30.1-13.6,30.1-30.3 c0-19.3-11.3-26.4-11.3-43.1c0-14,9.1-22.5,20.9-22.5c10.4,0,18.8,5.7,21.3,18.5C320.1,27.3,320.4,28.9,320.4,30.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1DCA7A"
    },
    d: "M329.3,41.5c-9.2,0-16.5,4.7-21.2,12.7V43.1h-9.2v92.4h9.2V70.3c0-13.3,9.2-21.2,20.4-21.2 c12.9,0,21.5,10,21.5,22.5c0,13.7-7.9,24.3-21.5,24.3c-3.9,0-7.1-0.7-9.9-1.9v7.9c2.9,0.9,6.7,1.6,9.9,1.6c19.2,0,30.8-14,30.8-31.9 C359.3,55.1,346.4,41.5,329.3,41.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1DCA7A"
    },
    d: "M194.7,41.5c-11.9,0-20.9,5.5-22.9,14.8h9.2c1.9-5.3,7.1-7.2,13.7-7.2c7.9,0,14.4,3.3,14.4,12.3v1.6 c0,3.2-1.6,5.2-5.7,5.2h-13.7c-12,0-20.3,6.5-20.3,17.3c0,10.5,8.9,18,21.2,18c7.6,0,14.7-2.9,18.7-9.7v8.1h9.1V61.5 C218.3,49.3,209.2,41.5,194.7,41.5z M209.1,80.5c0,10.7-8.3,15.6-17.1,15.6c-9.9,0-13.3-5.6-13.3-10.7c0-6.1,3.6-10.4,12.3-10.4 h10.7c3.1,0,6-0.5,7.5-2.3V80.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1DCA7A"
    },
    d: "M30.1,41.5C13.3,41.5,0,54.4,0,72.5c0,18.1,13.3,30.9,30.1,30.9c16.9,0,30.3-12.8,30.3-30.9 C60.4,54.4,47.1,41.5,30.1,41.5z M30.1,95.9c-12.5,0-20.8-10-20.8-23.3c0-13.5,8.3-23.5,20.8-23.5c12.7,0,20.9,10.1,20.9,23.5 C51.1,85.9,42.8,95.9,30.1,95.9z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmaSaastopankki);
export default __webpack_public_path__ + "static/media/oma-saastopankki.5b834561c6e1a2454ee32575e040f67a.svg";
export { ForwardRef as ReactComponent };